<div class="sdps-navigation--horizontal">
  <h1 class="sr-only">ADDLink</h1>
  <nav aria-label="ADDLink navigation"
       class="sdps-navigation--horizontal__levelFour subNavigation" id="unique-secondaryNav">
    <ul aria-label="ADDLink navigation steps" class="sdps-navigation--horizontal__nav">
      <ng-container *ngFor="let item of addLinkSubMenu;">
        <li class="sdps-navigation--horizontal__item" routerLinkActive="sdps-is-active"
          [ngClass]="!item.showLink || charitableClient ? 'demo-border-bottom':''">
          <a class="sdps-navigation--horizontal__link"
            *ngIf="item.showLink && !charitableClient && this.sharedService.checkAccess(item.accessName)">
            <button class="buttons sub-navigation-button" [routerLink]="item.route" [innerHTML]="item.name"
              [class.ui-disable-nav-tab]="(item.showLink && this.sharedService.checkAccess(item.accessName)) && (item.accessName === 'accountLinking' && sharedService.showHistoricalView.value)" [ngClass]="{'p-disabled': item.accessName === 'accountLinking' && sharedService.showHistoricalView.value}" (click)="sharedService.loadDataTrackValue(item.route)"></button>
          </a>
          <a class="sdps-navigation--horizontal__link"
            *ngIf="!item.showLink && !charitableClient && this.sharedService.checkAccess(item.accessName)"
            [innerHTML]="item.name" [class.ui-disable-nav-tab]="!item.showLink ? true: ''"
            [title]="sharedConstant.accessDeniedTooltipMessage">
          </a>
          <a class="sdps-navigation--horizontal__link"
            *ngIf="charitableClient && this.sharedService.checkAccess(item.accessName)" [innerHTML]="item.name"
            [class.ui-disable-nav-tab]="(charitableClient || sharedService.showHistoricalView.value) && item.name !== 'Request List' ? true: ''"
            [title]="sharedConstant.accessDeniedTooltipMessage">
            <button class="buttons sub-navigation-button" [routerLink]="item.route" [innerHTML]="item.name" *ngIf="charitableClient && item.name === 'Request List'"
            (click)="sharedService.loadDataTrackValue(item.route)"></button>
          </a>
        </li>
      </ng-container>
    </ul>
  </nav>

  <div class="content-area sdps-p-around_large">
    <ems-service-error  *ngIf="sharedService.showHistoricalView | async"></ems-service-error>

    <router-outlet></router-outlet>

  </div>
</div>
